import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

import { AVIDA_REACTION_SENTINEL } from '../../utils/reactions';

import {
  Container,
  Badge,
  AvidaEmoji,
  Count,
} from './styles';

const ReactionBar = ({
  reactions,
  viewerId,
  onToggle,
  avidaImageUrl,
}) => {
  const aggregated = useMemo(() => {
    const acc = {};
    Object.entries(reactions).forEach(([userId, emoji]) => {
      if (!acc[emoji]) {
        acc[emoji] = { count: 0, mine: false };
      }
      acc[emoji].count += 1;
      if (userId === viewerId) {
        acc[emoji].mine = true;
      }
    });
    return acc;
  }, [reactions, viewerId]);

  const entries = Object.entries(aggregated);
  if (entries.length === 0) {
    return null;
  }

  return (
    <Container>
      {entries.map(([emoji, { count, mine }]) => {
        const isAvida = emoji === AVIDA_REACTION_SENTINEL;
        return (
          <Badge
            key={emoji}
            type="button"
            $mine={mine}
            // The Avida sentinel is exclusive to the mirrored @Avida system user — clicking it
            // must not set a real user's reaction to the sentinel. Render it as a non-interactive badge.
            disabled={isAvida}
            onClick={isAvida ? undefined : () => onToggle(emoji)}
          >
            {isAvida
              ? <AvidaEmoji src={avidaImageUrl} alt="Avida" />
              : <span>{emoji}</span>}
            {count > 1 && <Count>{count}</Count>}
          </Badge>
        );
      })}
    </Container>
  );
};

ReactionBar.propTypes = {
  reactions: PropTypes.objectOf(PropTypes.string).isRequired,
  viewerId: PropTypes.string,
  onToggle: PropTypes.func.isRequired,
  avidaImageUrl: PropTypes.string,
};

ReactionBar.defaultProps = {
  viewerId: '',
  avidaImageUrl: '',
};

export default ReactionBar;
